
export default {
  name: 'UIPostTickerCardSkeleton',
};
